// const membershipApplicationPath = "https://storage.googleapis.com/alimanassets/sisbc/membership_application_form_2023_V4.pdf";
const membershipApplicationPath = "https://storage.googleapis.com/alimanassets/sisbc/membership_application_form_2026_V1.pdf";

const onClickMemberShipButton = () => {
    window.open(membershipApplicationPath)
}

export {
    membershipApplicationPath,
    onClickMemberShipButton
} 